import { pick } from 'lodash';
import {
  BULK_PROVISIONING_INITIAL_VALUES,
  BulkProvisioningFilters,
} from 'atoms/filters/bulk-provisioning.ts';
import { ProvisioningSourceFilter } from '@/activityLog/bulkProvisioning/constants/provisioningSource.ts';
import { ProvisioningStatusFilter } from '@/activityLog/bulkProvisioning/constants/provisioningStatus.ts';
import { cleanDefaultValuesURLSearchParams } from 'common/utils/urlSearchParamsUtils.ts';

export const mapBulkProvisioningFiltersToURLSearchParams = (filters: BulkProvisioningFilters) => {
  const filtersAsStrings = {
    ...filters,
    uploadDateFrom: filters.uploadDateFrom ? filters.uploadDateFrom.toISOString() : null,
    uploadDateTo: filters.uploadDateTo ? filters.uploadDateTo.toISOString() : null,
  };

  const cleanedFiltersValues = cleanDefaultValuesURLSearchParams(
    {
      ...filtersAsStrings,
    },
    {
      ...BULK_PROVISIONING_INITIAL_VALUES,
      uploadDateFrom: null,
      uploadDateTo: null,
    },
  );
  const searchParams = new URLSearchParams({
    ...cleanedFiltersValues,
  });
  return searchParams;
};

export const mapURLSearchParamsToBulkProvisioningFilers = (
  urlSearchParams: URLSearchParams,
): BulkProvisioningFilters => {
  const filters = Object.fromEntries(urlSearchParams);

  const { fileName, status, orderNumber, uploadDateFrom, uploadDateTo, source } = pick(
    filters,
    Object.keys(BULK_PROVISIONING_INITIAL_VALUES),
  );

  return {
    ...BULK_PROVISIONING_INITIAL_VALUES,
    fileName: fileName ?? BULK_PROVISIONING_INITIAL_VALUES.fileName,
    status: status ? (status as ProvisioningStatusFilter) : BULK_PROVISIONING_INITIAL_VALUES.status,
    orderNumber: orderNumber ?? BULK_PROVISIONING_INITIAL_VALUES.orderNumber,
    uploadDateFrom: uploadDateFrom
      ? new Date(uploadDateFrom)
      : BULK_PROVISIONING_INITIAL_VALUES.uploadDateFrom,
    uploadDateTo: uploadDateTo
      ? new Date(uploadDateTo)
      : BULK_PROVISIONING_INITIAL_VALUES.uploadDateTo,
    source: source
      ? (source.split(',').map((value) => +value) as ProvisioningSourceFilter)
      : BULK_PROVISIONING_INITIAL_VALUES.source,
  };
};
